import React, { Component,Fragment } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,MDBTableBody,MDBTable, MDBTableHead, MDBAlert, MDBSelect , MDBInput ,MDBFormInline   } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Spin, Space   } from 'antd';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import domtoimage from 'dom-to-image';

export default class Modaladdcurriculumopen extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,
  loading: false,

  Course_ID:'',
  Curriculumopen_ID:'1',
  Course_YEAR:'',
  Curriculumopen_TEAM:'',
  Curriculumopen_Full_Name_TH:'',
  Curriculumopen_Full_Name_EN:'',
  Curriculumopen_Detail_TH:'',
  Curriculumopen_Detail_EN:'',
  Curriculumopen_CH:'',
  Curriculumopen_NUM:'',
  Curriculumopen_Date_STARTRE:'',
  Curriculumopen_Date_ENDRE:'',
  Curriculumopen_Date_START:'',
  Curriculumopen_Date_END:'',
  Curriculumopen_User_UPDATE:'',
  Curriculumopen_Status_COURSE:'1',
  Curriculumopen_Status_ONOFF:'1',
  Univ_ID:'1',
  Univ_NAME:'',
  Faculty_ID:'',
  faculty:'',
  radio:'',
  Curriculumopen_Mook:'',
  typegrade:'',
}

//this.handleChange = this.handleChange.bind(this);
this.handleChangeName_EN = this.handleChangeName_EN.bind(this);
this.handleChangeName_TH = this.handleChangeName_TH.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChangeteam = this.handleChangeteam.bind(this);
this.handleChangeCH = this.handleChangeCH.bind(this);
this.handleChangeNUM = this.handleChangeNUM.bind(this);
this.handleChangeTIMESTART = this.handleChangeTIMESTART.bind(this);
this.handleChangeEND = this.handleChangeEND.bind(this);
this.handleChangeDetail_TH = this.handleChangeDetail_TH.bind(this);
this.handleChangeDetail_EN = this.handleChangeDetail_EN.bind(this);
this.handleChangeTIMESTARTRE = this.handleChangeTIMESTARTRE.bind(this);
this.handleChangeENDRE = this.handleChangeENDRE.bind(this);
this.onClickradio = this.onClickradio.bind(this);

this.handleChangetype = this.handleChangetype.bind(this);
this.handleChangetypegrade = this.handleChangetypegrade.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal,
    Course_ID:this.props.Course_ID
    
  });
 // this.props.getclassroom();
}

onClickradio = (nr) => () => {
  this.setState({
    radio: nr,
  });
};


//handleChange2(event) {    this.setState({send_comment1: event.target.value});  }


 componentDidMount() {

  //const { id_send } = this.props.id_send

  //console.log(id_send);
  this.setState({ Course_ID:this.props.Course_ID})
  this.setState({ Course_YEAR:this.props.Course_YEAR})
  this.setState({ Faculty_ID:this.props.Faculty_ID})
  this.setState({ Univ_ID:localStorage.getItem('Univ_ID')})
  this.setState({ Univ_NAME:localStorage.getItem('Univ_NAME')})
  this.setState({ Curriculumopen_User_UPDATE:localStorage.getItem('Citizen_ID')})
  this.setState({ faculty:localStorage.getItem('faculty')})
 
//     Axios.get(`https://arit.kpru.ac.th/ap/survey/api.php?nu=reports&code=20210719&PostionType=%E0%B8%99%E0%B8%B1%E0%B8%81%E0%B8%A8%E0%B8%B6%E0%B8%81%E0%B8%A9%E0%B8%B2&id=${this.props.faculty1send}&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D&fbclid=IwAR37lj-5gXs9k55vAErqiHHH-Nyr5WKEzJIY_M_O_fsHzazOYbxbyZwusg4`,
//     // Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
//      {headers: {
//         // Authorization: 'Bearer ' + localStorage.getItem('myData')
//      }
//      })
//    //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
//      .then(res => {
//         // console.log(res.data[0].id)
//          console.log(res.data)
//         // const studentok = res.data.filter( ({ message }) => message === "ฉีดวัคซีนแล้ว" );
//       //  const report8 = res.data.filter( ({ faculty_id }) => faculty_id === "8" );
//        //  const student = res.data;
//         //  this.setState({ studentnum : studentok});
//          const studentnotok = res.data.filter( ({ message }) => message === "ยังไม่ได้ฉีดวัคซีน" );
//          this.setState({ studentnumnot : studentnotok});
//      })

  }



  handleChangeteam(event) {    this.setState({Curriculumopen_TEAM: event.target.value});  }
  handleChangeName_TH(event) {    this.setState({Curriculumopen_Full_Name_TH: event.target.value});  }
  handleChangeName_EN(event) {    this.setState({Curriculumopen_Full_Name_EN: event.target.value});  }
  handleChangeDetail_TH(event) {    this.setState({Curriculumopen_Detail_TH: event.target.value});  }
  handleChangeDetail_EN(event) {    this.setState({Curriculumopen_Detail_EN: event.target.value});  }
  handleChangeCH(event) {    this.setState({Curriculumopen_CH: event.target.value});  }
  handleChangeNUM(event) {    this.setState({Curriculumopen_NUM: event.target.value});  }
  handleChangeTIMESTART(event) {    this.setState({Curriculumopen_Date_START: event.target.value});  }
 // handleChangeTIMESTART(event) {    this.setState({Curriculumopen_Date_START: event.target.value});  }
  handleChangeEND(event) {    this.setState({Curriculumopen_Date_END: event.target.value});  }

  handleChangeTIMESTARTRE(event) {    this.setState({Curriculumopen_Date_STARTRE: event.target.value});  }
  handleChangeENDRE(event) {    this.setState({Curriculumopen_Date_ENDRE: event.target.value});  }
  handleChangetype(event) {    this.setState({Curriculumopen_Mook: event.target.value});  }
  handleChangetypegrade(event) {    this.setState({typegrade: event.target.value});  }



  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
    console.log('เข้าไหม')
    this.setState({ loading : true });

   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("Course_ID", this.state.Course_ID);
      datafrm.append("Course_YEAR", this.state.Course_YEAR);
      datafrm.append("Curriculumopen_TEAM", this.state.Curriculumopen_TEAM);
      datafrm.append("Curriculumopen_Full_Name_TH", this.state.Curriculumopen_Full_Name_TH);
      datafrm.append("Curriculumopen_Full_Name_EN", this.state.Curriculumopen_Full_Name_EN);
      datafrm.append("Curriculumopen_Detail_TH", this.state.Curriculumopen_Detail_TH);
      datafrm.append("Curriculumopen_Detail_EN", this.state.Curriculumopen_Detail_EN);
      datafrm.append("Curriculumopen_CH", this.state.Curriculumopen_CH);
      datafrm.append("Curriculumopen_NUM", this.state.Curriculumopen_NUM);
      datafrm.append("Curriculumopen_Date_STARTRE", this.state.Curriculumopen_Date_STARTRE);
      datafrm.append("Curriculumopen_Date_ENDRE", this.state.Curriculumopen_Date_ENDRE);
      datafrm.append("Curriculumopen_Date_START", this.state.Curriculumopen_Date_START);
      datafrm.append("Curriculumopen_Date_END", this.state.Curriculumopen_Date_END);
      datafrm.append("Curriculumopen_User_UPDATE", this.state.Curriculumopen_User_UPDATE);
      datafrm.append("Curriculumopen_faculty", this.state.faculty);
      datafrm.append("Curriculumopen_Status_COURSE", this.state.Curriculumopen_Status_COURSE);
      datafrm.append("Curriculumopen_Status_ONOFF", this.state.Curriculumopen_Status_ONOFF);
      datafrm.append("Curriculumopen_Mook", this.state.Curriculumopen_Mook);
      datafrm.append("Univ_ID", this.state.Univ_ID);
      datafrm.append("Curriculumopen_typegrade", this.state.typegrade);
      
      Axios.post("https://mua.kpru.ac.th/FrontEnd_creditbank/index/AddCurriculumopen/",datafrm,{
        headers: {
            'content-type': 'multipart/form-data'
        }
      })

     .then(res => {
    //    console.log(res);
        if (res.status === 200) {
        //  alert("บันทึกสำเร็จ")

                  setTimeout(() => {
                    Axios.get('https://mua.kpru.ac.th/FrontEnd_creditbank/index/getCurriculumopenforupdate/'+this.state.Course_ID,
                    //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                      {headers: {
                      } })
                      .then(res => {
                        console.log(res.data[0].Curriculumopen_ID)
                        if (res.data[0].Curriculumopen_ID != 0) {

                                                    const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                                                    datafrm.append("Teacher_Citizen_ID", this.state.Curriculumopen_User_UPDATE);
                                                    datafrm.append("Curriculumopen_ID", res.data[0].Curriculumopen_ID);
                                                    datafrm.append("Univ_ID", res.data[0].Univ_ID);
                                                    
                                                    Axios.post("https://mua.kpru.ac.th/FrontEnd_creditbank/index/AddTeacherforcurriculum/",datafrm,{
                                                      headers: {
                                                          'content-type': 'multipart/form-data'
                                                      }
                                                    })

                                                   .then(res => {
                                                  //    console.log(res);
                                                      if (res.status === 200) {
                                                        this.setState({ loading : false });
                                                                  Swal.fire({
                                                                      title: 'บันทึกข้อมูลสำเร็จ',
                                                                      icon: 'success',
                                                                    // showCancelButton: true,
                                                                      confirmButtonText: 'ตกลง',
                                                                    // cancelButtonText: 'No, keep it'
                                                                    }).then((result) => {
                                                                      window.location.href = '/creditbank/Curriculum'
                                                                    })
                                                              }
                                                      })
                        }


                        //    console.log(res.data[0].id)
                        //   console.log(res.data)
                        //   const studentsearch = res.data;
                         //  this.setState({ studentsearch });
                      })
                  }, 2000);

                  // Swal.fire({
                  //     title: 'บันทึกข้อมูลสำเร็จ',
                  //     icon: 'success',
                  //   // showCancelButton: true,
                  //     confirmButtonText: 'ตกลง',
                  //   // cancelButtonText: 'No, keep it'
                  //   }).then((result) => {
                  //     window.location.href = '/creditbank/Curriculum'
                  //   })
          }
        })
      //  this.toggle()
      //  this.props.getclassroom()
    // window.location.href = '/creditbank/Curriculum'

}, 3000);

//window.location.href = '/creditbank/Curriculum'


//this.props.updateat();
//this.getExpert()
 
  }

    render() {
      //  console.log(this.state.Course_ID)
         console.log(this.state.Curriculumopen_Detail_TH)
         console.log(this.state.Curriculumopen_Detail_EN)
         console.log(this.state.Curriculumopen_NUM)
         console.log(this.state.Curriculumopen_Mook)
        // console.log(this.state.Curriculumopen_Date_START)
        // console.log(this.state.Curriculumopen_Date_END)


      let { sortedInfo, filteredInfo } = this.state;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
        
        return (
            <>
            {/* <MDBBtn onClick={this.toggle} color="deep-purple" size="sm">รายชื่อยังไม่ได้ฉีดวัคซีน</MDBBtn> */}
          <div> <MDBBtn className='text-center' onClick={this.toggle}  color="deep-purple" > + เพิ่มข้อมูลหลักสูตร</MDBBtn></div> 
            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}>เพิ่มข้อมูลหลักสูตร</MDBModalHeader>
              <MDBModalBody>
               
              <br/>
              <div id="pdfdiv">
              <form onSubmit={this.handleSubmit}>
            
      
                 <div className="form-group text-left">
                    <label htmlFor="example2">รหัสวิชา</label>
                    <input type="text" id="example2" className="form-control form-control-md" value={this.state.Course_ID} disabled  />
                </div>
                <div className="form-group text-left">
                    <label htmlFor="example2">วิชาปี</label>
                    <input type="text" id="example2" className="form-control form-control-md" value={this.state.Course_YEAR} disabled  />
                </div>
                <div className="form-group text-left">
                    <label htmlFor="example2">เทอม</label>
                    {/* <input type="text" id="example2" className="form-control form-control-md" value={this.state.Course_ID} onChange={this.handleChange4} /> */}
                    <div>
              <select className="browser-default custom-select"  onChange={this.handleChangeteam.bind(this)}  icon="user" required >
                <option>เลือกเทอม</option>
                <option value="3/2569">3/2569</option>
                <option value="2/2569">2/2569</option>
                <option value="1/2569">1/2569</option>
                <option value="3/2568">3/2568</option>
                <option value="2/2568">2/2568</option>
                <option value="1/2568">1/2568</option>
                <option value="3/2567">3/2567</option>
                <option value="2/2567">2/2567</option>
                <option value="1/2567">1/2567</option>
                <option value="2/2566">2/2566</option>
                <option value="1/2566">1/2566</option>
                <option value="2/2565">2/2565</option>
                <option value="1/2565">1/2565</option>
                <option value="2/2564">2/2564</option>
                <option value="1/2564">1/2564</option>
              </select> <br/>
            </div>
                </div>
                <div className="form-group text-left">
                    <label htmlFor="example2">ชื่อหลักสูตรภาษาไทย</label>
                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ ชื่อหลักสูตรภาษาไทย" value={this.state.Curriculumopen_Full_Name_TH} onChange={this.handleChangeName_TH} required />
                </div>
                <div className="form-group text-left">
                    <label htmlFor="example2">ชื่อหลักสูตรภาษาอังกฤษ</label>
                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ ชื่อหลักสูตรภาษาอังกฤษ" value={this.state.Curriculumopen_Full_Name_EN} onChange={this.handleChangeName_EN} />
                </div>
                <div className="form-group text-left">
                    <label htmlFor="example2">คำอธิบายรายวิชาภาษาไทย</label>
                    <textarea
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      placeholder="คำอธิบายรายวิชาภาษาไทย"
                      value={this.state.Curriculumopen_Detail_TH} onChange={this.handleChangeDetail_TH} 
                      rows="5"
                      />
                </div>
                <div className="form-group text-left">
                    <label htmlFor="example2">คำอธิบายรายวิชาภาษาอังกฤษ</label>
                    <textarea
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      placeholder="คำอธิบายรายวิชาภาษาอังกฤษ"
                      value={this.state.Curriculumopen_Detail_EN} onChange={this.handleChangeDetail_EN} 
                      rows="5"
                      />
                </div>
                <div className="form-group text-left">
                    <label htmlFor="example2">จำนวนชั่วโมง</label>
                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ จำนวนชั่วโมง" value={this.state.Curriculumopen_CH} onChange={this.handleChangeCH} required />
                </div>
                <div className="form-group text-left">
                    <label htmlFor="example2">จำนวนที่รับ</label>
                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ จำนวนที่รับ" value={this.state.Curriculumopen_NUM} onChange={this.handleChangeNUM} required />
                </div>
                {/* <div className="form-group">
                    <label htmlFor="example2">วันที่ เปิดลงทะเบียน</label>
                    <input type="date" id="example2" className="form-control form-control-md" onChange={this.handleChangeTIMESTARTRE}/>
                </div>
                <div className="form-group">
                    <label htmlFor="example2">วันที่ ปิดลงทะเบียน</label>
                    <input type="date" id="example2" className="form-control form-control-md"  onChange={this.handleChangeENDRE}/>
                </div> */}
                <div className="form-group text-left">
                    <label htmlFor="example2">วันที่ เปิดการสอน</label>
                    <input type="date" id="example2" className="form-control form-control-md" onChange={this.handleChangeTIMESTART} required/>
                </div>
                <div className="form-group text-left">
                    <label htmlFor="example2">วันที่ ปิดการสอน</label>
                    <input type="date" id="example2" className="form-control form-control-md"  onChange={this.handleChangeEND} required/>
                </div>

                <div className="form-group text-left">
                    <label htmlFor="example2">มีรายวิชาใน KPRU MOOC แล้วหรือไม่</label>
                    {/* <input type="text" id="example2" className="form-control form-control-md" value={this.state.Course_ID} onChange={this.handleChange4} /> */}
                    <div>
              <select className="browser-default custom-select"  onChange={this.handleChangetype.bind(this)}  icon="user" required >
                <option>เลือก</option>
                <option value="1">มี</option>
                <option value="0">ไม่มี</option>
               
              </select> <br/>
            </div>
                </div>

                 <div className="form-group text-left">
                    <label htmlFor="example2">ประเภทการให้เกรด</label>
                    {/* <input type="text" id="example2" className="form-control form-control-md" value={this.state.Course_ID} onChange={this.handleChange4} /> */}
                    <div>
              <select className="browser-default custom-select"  onChange={this.handleChangetypegrade.bind(this)}  icon="user" required >
                <option>เลือก</option>
                <option value="1">เกณฑ์การให้เกรดปกติ A-E</option>
                <option value="2">เกณฑ์การให้เกรด P/PD/F</option>
               
              </select> <br/>
            </div>
                </div>

                <div className="form-group text-left">
                    <label htmlFor="example2">มหาวิทยาลัย</label>
                    <input type="text" id="example2" className="form-control form-control-md" value={this.state.Univ_NAME} disabled/>
                </div>
                {/* <div className="text-center">
                <MDBBtn className="text-center" color="primary" type="submit" >บันทึก</MDBBtn>
                </div> */}
                   <div className="text-center form-group ">
             <MDBFormInline >
             <MDBInput
          gap
          onClick={this.onClickradio(1)}
          checked={this.state.radio === 1 ? true : false}
          label="ท่านยืนยันว่าตรวจสอบข้อมูลถูกต้องครบถ้วนแล้ว"
          type="radio"
          id="radio1"
          containerClass="mr-5"
        />
         </MDBFormInline>
             </div>
                </form>
            
              </div>
              </MDBModalBody>
{this.state.loading === true ? <> 
<div className="text-center">
  <Space size="middle">
    <Spin size="large" />
  </Space>
</div>
</> :<>
   <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                {this.state.Curriculumopen_TEAM !='' && this.state.Curriculumopen_Full_Name_TH !=''  && this.state.Curriculumopen_CH !='' && this.state.Curriculumopen_NUM !='' && this.state.Curriculumopen_Date_START !='' && this.state.Curriculumopen_Date_END !='' ?<>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> 
                </>:<>
                <MDBBtn color="primary" disabled >บันทึก</MDBBtn>
                
                </>}
                
              </MDBModalFooter>
  </>}

             

            </MDBModal>
          </>
         
        )
    }
}
